import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'cx-empty',
    templateUrl: './empty.component.html',
    styleUrls: ['./empty.component.scss'],
    standalone: true,
    imports: [NgIf]
})
export class EmptyComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle: string;

  constructor() { }

  ngOnInit(): void {
  }

}
